import FirebaseUsage from "../firebase.usage";
import {COLLECTIONS, SUB_COLLECTIONS} from "../constants";
import {DefaultSubscribeCallback} from "../../store/middleware/middlewares";
import TaskModel, {TaskSnapshot} from "../../models/responses/task.model";
import store from "../../store/store";
import TaskStatusModel from "../../models/responses/task-status.model";
import {TaskListSectionModel} from "../../models/task-list-section.model";
import {orderBy, query} from "firebase/firestore";
import {CpmLinkModel, CpmTaskModel} from "../../models/responses/cpm-task.model";
import {convertDateToIndex} from "../../utils/cpm-functions/cpm-app/functions/handleEvent";
import * as projectActions from "../../store/actions/project.actions";
import * as taskActions from "../../store/actions/task.actions";
import cpmFunctionsController from "../../utils/cpm-functions/cpm-functions.controller";

const handleStatusTypes = {
    [TaskStatusModel.COMPLETE]: 'completed',
    [TaskStatusModel.IN_PROGRESS]: 'in progress',
    [TaskStatusModel.NOT_STARTED]: 'not started',
    [TaskStatusModel.SUSPENDED]: 'in progress',
    [TaskStatusModel.BLOCK]: 'not started',
    [TaskStatusModel.DECLARED_COMPLETE]: 'completed',
}

const updateCPMMap = (cpmMap: any, taskList: TaskModel[], projectCalendars: any) => {
  let outCPMMap: Map<string, any> | null = cpmMap.size > 0 ? new Map(cpmMap) : null
  if (!outCPMMap) return
  if (outCPMMap.size === 0) return
  const timeStart = new Date().getTime() / 1000
  const dataDate = Math.floor(timeStart / 86400) * 86400
  taskList.forEach((task: TaskModel) => {
    const taskData: CpmTaskModel = outCPMMap!.get(task.task_id)
    if (taskData) {
      let cpmTask: CpmTaskModel = {
        ...taskData,
        es: task.early_start_date ? convertDateToIndex(task.early_start_date.seconds, taskData.cal_id, projectCalendars) : taskData.es,
        ef: task.early_end_date ? convertDateToIndex(task.early_end_date.seconds, taskData.cal_id, projectCalendars) : taskData.ef,
        ls: task.late_start_date ? convertDateToIndex(task.late_start_date.seconds, taskData.cal_id, projectCalendars) : taskData.ls,
        lf: task.late_end_date ? convertDateToIndex(task.late_end_date.seconds, taskData.cal_id, projectCalendars) : taskData.lf,
        status_code: task.status,
        predStatus: task.predStatus,
      }
      if (cpmTask.status_code === TaskStatusModel.DECLARED_COMPLETE || cpmTask.status_code === TaskStatusModel.COMPLETE) {
        cpmTask.duration = 0
      } else if (cpmTask.status_code === TaskStatusModel.IN_PROGRESS || cpmTask.status_code === TaskStatusModel.SUSPENDED) {
          cpmTask.duration = Math.max(0,
              convertDateToIndex(Math.floor(task.expiryDate!.seconds / 1800) * 1800, taskData.cal_id, projectCalendars) -
              convertDateToIndex(dataDate, taskData.cal_id, projectCalendars))
      } else {
        // @ts-ignore
        cpmTask.duration = taskData.ef - taskData.es
      }
      outCPMMap!.set(task.task_id, cpmTask)
    }
  })
  store.dispatch(projectActions.Actions.setCpmMap(outCPMMap))
  outCPMMap = null
}

const updateCPMMapLite = (
    cpmMap: any,
    taskList: TaskModel[],
    projectCalendars: any,
    completedChecklistMap: any,
    originalTaskMap: Map<string, TaskModel>,
    projectId: string,
    contractId: string | null = null,
    projectDataDate: number | null = null,
    taskCodeMap: Map<string, string>
) => {
  if (!cpmMap) return
  if (cpmMap.size === 0 && originalTaskMap.size === 0) {
      let newTaskMap = new Map<string, TaskModel>()
      taskList.forEach((task: TaskModel) => {
          if (task.deleted) return
          if (task.completedChecklist && task.completedChecklist.length > 0) {
              task.completedChecklist.forEach(item => completedChecklistMap.set(`${task.task_id}:${item.id}`, item))
          }
          newTaskMap.set(task.task_id, task)
          taskCodeMap.set(task.task_code, task.task_id)
      })
      store.dispatch(taskActions.Actions.setAllTaskList(newTaskMap));
      store.dispatch(taskActions.Actions.setTaskListLoadProjectId(projectId));
      return;
  }
  const timeStart = new Date().getTime() / 1000;
  const dataDate = projectDataDate ? projectDataDate : Math.floor(timeStart / 86400) * 86400;
  const activeTask = store.getState().task.activeTask;
  taskList.forEach((task: TaskModel) => {
    if (task.deleted) {
        originalTaskMap.delete(task.task_id)
        cpmMap.delete(task.task_id)
        taskCodeMap.delete(task.task_code)
        if (activeTask && activeTask.task_id === task.task_id) {
            store.dispatch(taskActions.Actions.setActiveTask(null))
        }
        return
    }
    if (task.completedChecklist && task.completedChecklist.length > 0) {
        task.completedChecklist.forEach(item => completedChecklistMap.set(`${task.task_id}:${item.id}`, item))
    }
    if (activeTask && activeTask.task_id === task.task_id) {
        store.dispatch(taskActions.Actions.setActiveTask(task))
    }
    const taskData: CpmTaskModel = cpmMap.get(task.task_id)
    if (taskData) {
      const originalTask = originalTaskMap.get(task.task_id);
      if (!originalTask) return;
      let cpmTask: CpmTaskModel = {
        ...taskData,
        status_code: task.status,
        predStatus: task.predStatus,
      };
      let changeThatRequiresUpdate = false;

      if (task.status !== originalTask.status) {
          if (handleStatusTypes[task.status] === 'completed' && handleStatusTypes[originalTask.status] !== 'completed') {
              changeThatRequiresUpdate = true;
              cpmTask.duration = 0;
              cpmTask.ef = task.act_end_date ?
                    convertDateToIndex(Math.floor(task.act_end_date.seconds / 1800) / 1800, taskData.cal_id, projectCalendars) :
                    task.declaredCompleteTimestamp ?
                        convertDateToIndex(Math.floor(task.declaredCompleteTimestamp.seconds / 1800) * 1800, taskData.cal_id, projectCalendars) :
                        cpmTask.ef;
          } else if (handleStatusTypes[task.status] === 'in progress') {
                changeThatRequiresUpdate = true;
                cpmTask.duration = Math.max(0,
                    convertDateToIndex(Math.floor(task.expiryDate!.seconds / 1800) * 1800, taskData.cal_id, projectCalendars) -
                    convertDateToIndex(dataDate, taskData.cal_id, projectCalendars));
                // @ts-ignore
                cpmTask.ef = cpmTask.ad + cpmTask.duration;
          }
      }

      if (task.flConstraintDate) {
          if (!originalTask.flConstraintDate || (originalTask.flConstraintDate && originalTask.flConstraintDate.seconds !== task.flConstraintDate.seconds)) {
              console.log('task constraint date changed', task.task_code)
              changeThatRequiresUpdate = true;
              const constraintDateAsIndex = convertDateToIndex(
                  Math.floor(task.flConstraintDate.seconds / 1800) * 1800,
                  taskData.cal_id,
                  projectCalendars
              );
              const preds = cpmMap.get(`${task.task_id}:preds`);
              cpmTask.ad = Math.max(constraintDateAsIndex, Math.max(preds.map(pred => cpmMap.get(pred).ad)));
              cpmTask.es = cpmTask.status_code === TaskStatusModel.COMPLETE || cpmTask.status_code === TaskStatusModel.DECLARED_COMPLETE ?
                  cpmTask.es : cpmTask.status_code === TaskStatusModel.IN_PROGRESS || cpmTask.status_code === TaskStatusModel.SUSPENDED ?
                      cpmTask.es : cpmTask.ad;
              cpmTask.ef = cpmTask.status_code === TaskStatusModel.COMPLETE || cpmTask.status_code === TaskStatusModel.DECLARED_COMPLETE ? cpmTask.ef : cpmTask.status_code === TaskStatusModel.IN_PROGRESS || cpmTask.status_code === TaskStatusModel.SUSPENDED ?
                  // @ts-ignore
                  cpmTask.ef : cpmTask.es + cpmTask.duration;
          }
      } else if (originalTask.flConstraintDate) {
          changeThatRequiresUpdate = true;
          const preds = cpmMap.get(`${task.task_id}:preds`);
          cpmTask.ad = Math.max(preds.map(pred => cpmMap.get(pred).ad));
          cpmTask.es = cpmTask.status_code !== TaskStatusModel.COMPLETE && cpmTask.status_code !== TaskStatusModel.DECLARED_COMPLETE ?
                cpmTask.es : cpmTask.ad;
            cpmTask.ef = cpmTask.status_code === TaskStatusModel.COMPLETE || cpmTask.status_code === TaskStatusModel.DECLARED_COMPLETE ?
                cpmTask.ef : cpmTask.ad + cpmTask.duration;
      }

      // task has been reforecasted
      if (task.expiryDate && originalTask.expiryDate && originalTask.expiryDate.seconds !== task.expiryDate.seconds) {
          console.log('task expiry date changed', task.task_code, task.expiryDate, originalTask.expiryDate)
          changeThatRequiresUpdate = true;
          cpmTask.duration = Math.max(0,
              convertDateToIndex(Math.floor(task.expiryDate!.seconds / 1800) * 1800, taskData.cal_id, projectCalendars) -
              convertDateToIndex(dataDate, taskData.cal_id, projectCalendars))
          // @ts-ignore
          cpmTask.ef = cpmTask.ad + cpmTask.duration;
      }

      if (changeThatRequiresUpdate) {
          cpmFunctionsController.miniCpmRefresh({
              project_id: projectId,
              task_id: task.task_id,
              contract_id: contractId,
              data_date: dataDate,
          }, store.dispatch).catch(e => console.error(e));
      }

      // TODO: capture end date updates
      console.log(task.task_code, 'updated')
      originalTaskMap.set(task.task_id, task)
      taskCodeMap.set(task.task_code, task.task_id)
      cpmMap.set(task.task_id, cpmTask)
    }
  })
}


export const generateTaskFromSnapshot = (data: any, projectId: string) => {
  const changes = data.docChanges();
  const originalTaskMap = store.getState().task.tasks;

  let changeList : any[] = [];
  changes.forEach((change: any) => {
      changeList.push({
          ...change.doc.data()
            , docRef: change.doc.ref,
            // status: change.doc.data().status.toLowerCase(),
      })
  });
    if (changeList.length > 0) {
      updateCPMMapLite(
          store.getState().project.cpmMap,
          changeList, store.getState().project.activeProjectCalendars,
          store.getState().task.completedChecklistMap,
          originalTaskMap,
          projectId,
          store.getState().project.activeProject?.contractId || null,
          store.getState().project.activeProject && store.getState().project.activeProject!.frozenDate ?
              Math.floor(store.getState().project.activeProject!.frozenDate!.seconds / 86400) * 86400 : null,
          store.getState().task.taskCodeMap
      );
    }

  return data.docs
      .map((doc: any) => {
        const d = doc.data();
        return {
          ...d,
          status: d.status.toLowerCase(),
          docRef: doc.ref
        } as TaskModel;
      })
      .filter((task: TaskModel) => !task.deleted)
};

export interface TaskListSubscriptionParameters {
  project_id: string;
  taskListType?: TaskListSectionModel;
  statuses?: Array<TaskStatusModel | string>;
  status: TaskStatusModel;
  taskForces: Array<string>;
  page: number;
  flow?: boolean;
  alert: boolean;
  searchValue?: string;
}

export interface RelatedTasksSubscriptionParameters {
  project_id: string;
  taskId: string;
}

export class TaskSubscriptions {
  static getTaskListRef(
    params: Pick<
      TaskListSubscriptionParameters,
      "project_id" | "page" | "taskListType" | "statuses" | "status"
    >
  ) {
    if (params.statuses && params.statuses!.length > 0) {
      params.statuses = params.statuses!.filter(
        (stat) => stat !== TaskStatusModel.RETIRED
      );
    } else {
      params.statuses = Object.values(TaskStatusModel).filter(
        (stat) => stat !== TaskStatusModel.RETIRED
      );
    }
    if (params.status === TaskStatusModel.COMPLETE) {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
            ["status", "==", params.status],
        ]);
    } else if (params.status === TaskStatusModel.DECLARED_COMPLETE) {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
            ["status", "==", params.status],
        ]);
    } else if (params.status === TaskStatusModel.IN_PROGRESS) {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
            ["status", "==", params.status],
            ["flow", "==", true]
        ]);
    } else if (params.status === TaskStatusModel.NOT_STARTED) {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
            ["status", "==", params.status],
            ["flow", "==", false]
        ]);
    } else if (params.taskListType === TaskListSectionModel.PENDING) {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
            ["taskListType", "==", params.taskListType],
        ]);
    } else {
        return FirebaseUsage.getCompoundQueryAsQuery(COLLECTIONS.TASKS, [
            ["projectId", "==", params.project_id],
        ]);
    }
  }

  // static async taskList(
  //   params: TaskListSubscriptionParameters,
  //   callback: DefaultSubscribeCallback<TaskModel[]>
  // ) {
  //   let qRef = await TaskSubscriptions.getTaskListRef(params);
  //   if (params.status === TaskStatusModel.COMPLETE) {
  //     qRef = query(qRef, orderBy("act_end_date", "desc"));
  //   } else if (params.status === TaskStatusModel.DECLARED_COMPLETE) {
  //     qRef = query(qRef, orderBy("declaredCompleteTimestamp", "desc"));
  //   } else if (params.status === TaskStatusModel.IN_PROGRESS) {
  //     qRef = query(qRef, orderBy("late_start_date"));
  //   } else if (params.status === TaskStatusModel.NOT_STARTED) {
  //     qRef = query(qRef, orderBy("forecastDate"));
  //   } else if (params.taskListType === TaskListSectionModel.PENDING) {
  //       qRef = query(qRef, orderBy("taskCreatedTimestamp"));
  //   } else {
  //       qRef = query(qRef, orderBy("forecastDate"));
  //   }
  //
  //   return await FirebaseUsage.queryListenerRef(
  //     qRef,
  //     (data: any) => callback(generateTaskFromSnapshot(data))
  //   );
  // }

  static completeTaskList( projectId: string, callback: DefaultSubscribeCallback<TaskModel[]>) {
    return FirebaseUsage.queryListener(COLLECTIONS.TASKS, [
        ["projectId", "==", projectId]
    ], (docs: TaskModel[]) => callback(generateTaskFromSnapshot(docs, projectId)));
  }

  static successorsList(
    params: RelatedTasksSubscriptionParameters,
    callback: DefaultSubscribeCallback<TaskModel[]>
  ) {
    const allTasks = store.getState().task.tasks
    const relationshipsList = store.getState().relationships.relationshipsList;
    const taskIdsQuery = relationshipsList
      .filter((relation) => relation.pred_task_id === params.taskId)
      .map((relation) => relation.task_id);

    if (!Boolean(taskIdsQuery.length)) {
      return () => callback([]);
    }

      let predTasks: any[] = []
      allTasks.forEach((task, _) => {
          if (taskIdsQuery.includes(task.task_id)) {
              predTasks.push(task)
          }
      })
    return callback(predTasks)
  }

  static predecessorsList(
    params: RelatedTasksSubscriptionParameters,
    callback: DefaultSubscribeCallback<TaskModel[]>
  ) {
    const allTasks = store.getState().task.tasks

    const relationshipsList = store.getState().relationships.relationshipsList;
    const taskIdsQuery = relationshipsList
      .filter((relation) => relation.task_id === params.taskId)
      .map((relation) => relation.pred_task_id);

    if (!Boolean(taskIdsQuery.length)) {
      return () => callback([]);
    }

    let predTasks: any[] = []
    allTasks.forEach((task, _) => {
        if (taskIdsQuery.includes(task.task_id)) {
            predTasks.push(task)
        }
    })
    return callback(predTasks)
  }

  static async taskSnapshot(
      dataVersionId: string,
      contractId: string,
      callback: DefaultSubscribeCallback<Map <string, TaskSnapshot>>) {
        let taskSnapshotMap = new Map<string, TaskSnapshot>()
        await FirebaseUsage.getCompoundQuery(COLLECTIONS.TASK_SNAPSHOTS, [
            ["dataVersionId", "==", dataVersionId],
            ["contractId", "==", contractId]])
            .then((snapshot) =>
                snapshot.docs.forEach((doc) => {
                    const data = doc.data()
                    taskSnapshotMap.set(data.taskCode, data as TaskSnapshot)
                }))
        return callback(taskSnapshotMap)
  }

  static async taskSnapshots(
      taskCode: string,
      contractId: string,
      dataVersionMap: Map<string, number>,
      callback: DefaultSubscribeCallback
  ) {
      const taskSnaps = await FirebaseUsage.getCompoundQuery(COLLECTIONS.TASK_SNAPSHOTS, [
            ["taskCode", "==", taskCode],
            ["contractId", "==", contractId]])
            .then((snapshot) =>
                snapshot.docs
                    .map((doc) => {
                        const data = doc.data()
                        const dataceVersionTimestamp = dataVersionMap.get(data.dataVersionId)
                        if (!dataceVersionTimestamp) return null
                        return {...data, timestamp: dataVersionMap.get(data.dataVersionId) || 0} as TaskSnapshot & {timestamp: number}
                    })
                    .filter((snap) => snap !== null) // @ts-ignore
                    .sort((a, b) => a.timestamp - b.timestamp)
            );
      return callback(taskSnaps)
  }

  static async userPlaylists(
      userId: string,
      contractId: string,
      callback: DefaultSubscribeCallback
  ) {
      const playlists = await FirebaseUsage.getCompoundQueryWithOrder(COLLECTIONS.DAILY_PLAYLISTS, [
          ["userId", "==", userId],
          ["contractId", "==", contractId]
      ], ["timestamp", "desc"])
          .then((snapshot) =>
              snapshot.docs.map((doc) => doc.data()))

      const newestPlaylist = playlists.length >= 1 ? playlists[0] : null
      const playlistItems = newestPlaylist ? await FirebaseUsage.getSubCollection(
          COLLECTIONS.DAILY_PLAYLISTS,
          newestPlaylist.playlistId,
          SUB_COLLECTIONS.PLAYLIST_ITEMS)
          .then((snapshot) => snapshot.docs.map((doc) => doc.data())) : []

      return callback({playlists, playlistItems})
  }
}
